import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const Star = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7323 17.6638C11.5868 17.5875 11.4132 17.5875 11.2677 17.6638L6.21161 20.3159C5.84459 20.5085 5.41614 20.1965 5.48664 19.7881L6.45495 14.1784C6.48313 14.0151 6.4286 13.8485 6.30936 13.7335L2.2335 9.80185C1.93445 9.51339 2.09731 9.00719 2.50846 8.94723L8.15341 8.1239C8.31667 8.10009 8.45768 7.99726 8.53026 7.84909L11.0525 2.70006C11.2352 2.32724 11.7663 2.32651 11.95 2.69882L14.4703 7.80813C14.5426 7.95468 14.682 8.05666 14.8435 8.08124L20.5003 8.94217C20.9097 9.00447 21.0702 9.50887 20.7722 9.79634L16.6906 13.7335C16.5714 13.8485 16.5169 14.0151 16.5451 14.1784L17.5134 19.7881C17.5839 20.1965 17.1554 20.5085 16.7884 20.3159L11.7323 17.6638Z"
      fill="currentFill"
    />
  </svg>
));

export default Star;
